<div [kgrLoading]="isLoading" [kgrLoadingBlocking]="true">
  <h2 class="kgr-headline kgr-headline--h3 kgr-row kgr-row--extraSmallMargin" i18n>Zwei-Faktor-Authentifizierung</h2>
  @if (useBackupCode) {
    <p class="kgr-paragraph kgr-row" i18n>8-stelligen Backup-Code eingeben:</p>
  } @else {
    <p class="kgr-paragraph kgr-row" i18n>6-stelligen Code aus der Authenticator-App eingeben:</p>
  }

  @if (errorInvalidCode) {
    <kgr-errors errors="Der eingegebene Code ist ungültig. Bitte erneut versuchen." i18n-errors></kgr-errors>
  }
  @if (errorOffline) {
    <kgr-errors errors="Es konnte keine Verbindung zum Server hergestellt werden." i18n-errors></kgr-errors>
  }
  @if (errorTooManyAttempts) {
    <kgr-errors errors="Zu viele fehlgeschlagene Versuche. Bitte warte einen Moment und versuche es erneut." i18n-errors></kgr-errors>
  }
  @if (unexpectedError) {
    <kgr-errors errors="Es ist leider ein unerwarteter Fehler aufgetreten." i18n-errors></kgr-errors>
  }

  <form (submit)="onSubmit()" [formGroup]="form">
    <div class="kgr-grid kgr-grid--full kgr-grid--large-fit kgr-grid--gutters kgr-grid--bottom kgr-row">
      <div class="kgr-grid__cell">
        <kgr-form-field [label]="codeLabel" [constrainedWidth]="false">
          <kgr-code-input formControlName="code" [length]="codeLength" [alphanumeric]="useBackupCode"></kgr-code-input>
        </kgr-form-field>
      </div>
      <div class="kgr-grid__cell kgr-grid__cell--bottom">
        <button [disabled]="isLoading || errorTooManyAttempts" type="submit" class="kgr-button kgr-button--block kgr-button--accent" i18n>
          Code bestätigen
        </button>
      </div>
    </div>

    <!--    <kgr-form-field [constrainedWidth]="false" class="kgr-row">-->
    <!--      <kgr-checkbox-control formControlName="trustedDevice" label="Diesem Gerät 30 Tage vertrauen" i18n-label></kgr-checkbox-control>-->
    <!--    </kgr-form-field>-->

    <div class="kgr-row">
      <button type="button" class="kgr-link kgr-clickable kgr-clickable--touchy" (click)="onToggleBackupCode()">
        @if (useBackupCode) {
          <ng-container i18n>Mit Authenticator-App einloggen</ng-container>
        } @else {
          <ng-container i18n>Verifizierung mit Backup-Code</ng-container>
        }
      </button>
    </div>

    <button type="button" class="kgr-link kgr-clickable kgr-clickable--touchy" (click)="onCancel()" i18n>Zurück zur Anmeldung</button>
  </form>
</div>
